/**
 * @generated SignedSource<<cdd2e55c12a141f9bde56b28924bdf2b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type luminaUserInlinePreviewListRelay_knowledgeDiscovery$data = {
  readonly searchUsersV2: {
    readonly __typename: "KnowledgeDiscoverySearchUsers";
    readonly users: ReadonlyArray<{
      readonly avatarUrl: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly thirdPartyIntegrations: ReadonlyArray<{
        readonly externalId: string;
        readonly integrationId: string;
        readonly product: string;
      }> | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "luminaUserInlinePreviewListRelay_knowledgeDiscovery";
};
export type luminaUserInlinePreviewListRelay_knowledgeDiscovery$key = {
  readonly " $data"?: luminaUserInlinePreviewListRelay_knowledgeDiscovery$data;
  readonly " $fragmentSpreads": FragmentRefs<"luminaUserInlinePreviewListRelay_knowledgeDiscovery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requestingUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "luminaUserInlinePreviewListRelay_knowledgeDiscovery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountIds",
          "variableName": "accountIds"
        },
        {
          "kind": "Variable",
          "name": "requestingUserId",
          "variableName": "requestingUserId"
        },
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "kind": "LinkedField",
      "name": "searchUsersV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoverySearchUserCard",
              "kind": "LinkedField",
              "name": "users",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "avatarUrl"
                },
                {
                  "kind": "ScalarField",
                  "name": "title"
                },
                {
                  "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                  "kind": "LinkedField",
                  "name": "thirdPartyIntegrations",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "integrationId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "product"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "KnowledgeDiscoverySearchUsers"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};

(node as any).hash = "9f60ef184700987177181d3be2a692a0";

export default node;
